<template>
  <v-tooltip top
             nudge-bottom="8">
    <template v-slot:activator="{on}">
      <span class="dmb-form-text warning--text"
           v-on="on">
        <slot></slot>
      </span>
    </template>
    <span class="caption">Schubladentarif</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "SchubladeTooltip"
};
</script>

